import React from 'react';
import { cn } from 'lib/utils';
import { Button } from 'components/ui/button';

/** Sticks to the bottom of its scroll container. Labels are passed in already localized. */
export interface SaveBarProps {
  /** Render only when there are unsaved changes. */
  visible?: boolean;
  message: React.ReactNode;
  saveLabel: string;
  onSave: () => void;
  /** Discard is shown only when both the label and handler are provided. */
  discardLabel?: string;
  onDiscard?: () => void;
  /** Disables the actions while the save is in flight. */
  saving?: boolean;
  className?: string;
}

export function SaveBar({
  visible = true,
  message,
  saveLabel,
  onSave,
  discardLabel,
  onDiscard,
  saving,
  className,
}: SaveBarProps) {
  if (!visible) return null;
  return (
    <div
      className={cn(
        'sticky bottom-0 z-20 flex items-center justify-between gap-3 border-t border-border bg-background/95 px-4 py-3 shadow-[0_-1px_3px_rgba(0,0,0,0.05)] backdrop-blur supports-[backdrop-filter]:bg-background/80',
        className,
      )}
    >
      <span className="flex items-center gap-2 text-sm text-muted-foreground">
        <span className="h-2 w-2 shrink-0 rounded-full bg-warning-500" aria-hidden />
        {message}
      </span>
      <div className="flex items-center gap-2">
        {discardLabel && onDiscard && (
          <Button variant="outline" size="sm" onClick={onDiscard} disabled={saving}>
            {discardLabel}
          </Button>
        )}
        <Button size="sm" onClick={onSave} disabled={saving}>
          {saveLabel}
        </Button>
      </div>
    </div>
  );
}

export default SaveBar;
